import React from 'react';
import { Row, Col } from 'react-bootstrap';
import CustomClientError from '../../../../errorhandling/CustomClientError';
import AccountDetailsGrid from './AccountDetailsGrid';
import { AccountDetailsPanel } from './AccountDetailsPanel';
import PlanDetailsSkeleton from './skeleton/PlanDetailsSkeleton';
import GridSkeleton from './skeleton/GridSkeleton';

const AccountDetails = ({
  dataFetching,
  isAPIFailed,
  coverageDataAPI,
  coverageDataisNotFound,
  isNotFound,
  isFamilySelected,
  Transactions,
  TotalDeposit,
  TotalWithdrawl,
  activeMemType,
  activeOID,
  membersCovered,
  planDetails,
  coverageData,
  activeAccountName,
  ...otherProps
}) => {
  const checkMemberType = () => (
    <>
      {activeMemType === 'Dependent' ? (
        <CustomClientError
          ErrorHeading="Account Summary is not available for Dependent."
          ErrorMessage="To view Account Summary, select a Member from Show Details drop-drown. "
        />
      ) : (
        <CustomClientError
          ErrorHeading="Something went wrong with request!"
          ErrorMessage="Please try again."
        />
      )}
    </>
  );
  return (
    <>
      <div className="coverage-details container-offset">
        {isAPIFailed ? (
          isNotFound ? (
            isFamilySelected ? (
              <CustomClientError
                ErrorHeading="Account Summary is not available for Family."
                ErrorMessage="To view Account Summary, select a Member from Show Details drop-drown. "
              />
            ) : (
              <CustomClientError
                ErrorHeading="No Spending Account found!"
                ErrorMessage="The selected Member does not have any Spending Account. "
              />
            )
          ) : (
            checkMemberType()
          )
        ) : (
          <>
            <Row className="">
              <Col xs={12} className="padding-mobile-0">
                {coverageData ? (
                  <AccountDetailsPanel
                    {...otherProps}
                    planDetails={planDetails}
                    isAPIFailed={coverageDataAPI}
                    isNotFound={coverageDataisNotFound}
                    activeMemType={activeMemType}
                    activeOID={activeOID}
                    membersCovered={membersCovered}
                    coverageData={coverageData}
                    activeAccountName={activeAccountName}
                  />
                ) : (
                  <PlanDetailsSkeleton />
                )}
              </Col>
            </Row>

            <Row className="mt-4">
              {dataFetching ? (
                <GridSkeleton />
              ) : Transactions?.length > 0 ? (
                <AccountDetailsGrid
                  dataFetching={dataFetching}
                  isAPIFailed={isAPIFailed}
                  Transactions={Transactions}
                  TotalDeposit={TotalDeposit}
                  TotalWithdrawl={TotalWithdrawl}
                  preserveData={otherProps.preserveData}
                />
              ) : (
                <Col xs={12}>
                  <CustomClientError
                    ErrorHeading="No Transactions found!"
                    ErrorMessage="The selected Member does not have any Transactions."
                    CustomClasses="p-0 m-0"
                  />
                </Col>
              )}
            </Row>
          </>
        )}
      </div>
    </>
  );
};

export default AccountDetails;
